import { ResponsiveImageDimensions } from '../utils/ResponsiveImage/ResponsiveImage.models';

export enum RenderMode {
  LayeringEngine = 'LAYRING_ENGINE',
  Image = 'IMAGE'
}

export enum HouseView {
  Outside = 'OUTSIDE',
  Inside = 'INSIDE'
}

export const layeringEngineMediaDimenstions: ResponsiveImageDimensions = {
  MQ1: [480, 480],
  MQ2: [768, 768],
  MQ3: [1024, 1024],
  MQ4: [1280, 1280],
  MQ5: [1440, 1440],
  MQ6: [1920, 1920]
};

export const imageMediaDimenstions: ResponsiveImageDimensions = {
  MQ1: [480, 480],
  MQ2: [768, 768],
  MQ3: [1024, 576],
  MQ4: [1280, 720],
  MQ5: [1440, 810],
  MQ6: [1920, 1080]
};
